import createReducer from './createReducer';
import {
  FETCH_USER_DETAILS,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  FETCH_USER_ENTITLEMENTS,
  FETCH_USER_ENTITLEMENTS_SUCCESS,
  FETCH_USER_ENTITLEMENTS_FAILURE,
  CREATE_USER_FAVORITE,
  CREATE_USER_FAVORITE_SUCCESS,
  CREATE_USER_FAVORITE_FAILURE,
  FETCH_USER_FAVORITES,
  FETCH_USER_FAVORITES_SUCCESS,
  FETCH_USER_FAVORITES_FAILURE,
  EDIT_USER_FAVORITE,
  RESET_USER_FAVORITE,
  UPDATE_USER_FAVORITE,
  UPDATE_USER_FAVORITE_SUCCESS,
  UPDATE_USER_FAVORITE_FAILURE,
  UPDATE_USER_FAVORITES,
  UPDATE_USER_FAVORITES_FAILURE,
  DELETE_USER_FAVORITE,
  DELETE_USER_FAVORITE_SUCCESS,
  DELETE_USER_FAVORITE_FAILURE,
  USER_FAVORITES_ACTIVE,
  USER_FAVORITES_NEW_INVALID,
  FETCH_USER_SETTINGS,
  FETCH_USER_SETTINGS_SUCCESS,
  FETCH_USER_SETTINGS_FAILURE,
  FETCH_PAYMENT_WARNINGS,
  FETCH_PAYMENT_WARNINGS_SUCCESS,
  FETCH_PAYMENT_WARNINGS_FAILURE,
  SET_USER_LOCATION,
  SET_USER_LOCATION_SUCCESS,
  SET_USER_LOCATION_FAILURE,
  SET_DFP_AD_ATTRIBUTES,
  SET_DFP_AD_ATTRIBUTES_SUCCESS,
  SET_DFP_AD_ATTRIBUTES_FAILURE,
  SET_USER_BW_WIND_WAVE_MODEL,
  SET_USER_BW_WIND_WAVE_MODEL_SUCCESS,
  SET_USER_BW_WIND_WAVE_MODEL_FAILURE,
  SET_USER_BW_UNIT_PREFERENCE,
  SET_USER_BW_UNIT_PREFERENCE_SUCCESS,
  SET_USER_BW_UNIT_PREFERENCE_FAILURE,
} from '../actions/user';

const augmentFavorite = favorite => ({
  ...favorite,
  dbName: favorite.name,
});

const initialState = {
  loading: false,
  error: null,
  details: null,
  entitlements: [],
  favorites: {
    active: false,
    favoriteInvalid: false,
    error: null,
    data: [],
  },
  legacyEntitlements: [],
  settings: {
    bwWindWaveModel: 'LOLA',
  },
};

const handlers = {};

handlers[FETCH_USER_DETAILS] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_USER_DETAILS_SUCCESS] = (state, { details }) => ({
  ...state,
  loading: false,
  details: {
    firstName: details.firstName,
    lastName: details.lastName,
    email: details.email,
    _id: details._id,
    legacyId: details.usID,
  },
});

handlers[FETCH_USER_DETAILS_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[FETCH_USER_ENTITLEMENTS] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_USER_ENTITLEMENTS_SUCCESS] = (state, { entitlements, legacyEntitlements }) => ({
  ...state,
  loading: false,
  entitlements,
  legacyEntitlements,
});

handlers[FETCH_USER_ENTITLEMENTS_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[CREATE_USER_FAVORITE] = state => ({
  ...state,
  loading: true,
});

handlers[CREATE_USER_FAVORITE_SUCCESS] = (state, { favorite }) => ({
  ...state,
  loading: false,
  favorites: {
    ...state.favorites,
    data: [
      ...state.favorites.data,
      favorite,
    ],
  },
});

handlers[CREATE_USER_FAVORITE_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  favorites: {
    ...state.favorites,
    error,
    data: [
      ...state.favorites.data,
    ],
  },
});

handlers[FETCH_USER_FAVORITES] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_USER_FAVORITES_SUCCESS] = (state, { favorites }) => ({
  ...state,
  loading: false,
  favorites: {
    ...state.favorites,
    data: favorites.map(fav => augmentFavorite(fav)),
  },
});

handlers[FETCH_USER_FAVORITES_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[EDIT_USER_FAVORITE] = (state, { favorite }) => ({
  ...state,
  favorites: {
    ...state.favorites,
    data: state.favorites.data.map((fav) => {
      if (fav._id === favorite._id) {
        return favorite;
      }
      return fav;
    }),
  },
});

handlers[RESET_USER_FAVORITE] = (state, { id }) => ({
  ...state,
  favorites: {
    active: false,
    data: state.favorites.data.map((fav) => {
      if (fav._id === id) {
        return {
          ...fav,
          name: fav.dbName,
        };
      }
      return fav;
    }),
  },
});

handlers[UPDATE_USER_FAVORITE] = state => ({
  ...state,
  loading: true,
});

handlers[UPDATE_USER_FAVORITE_SUCCESS] = (state, { id }) => ({
  ...state,
  loading: false,
  favorites: {
    active: false,
    data: state.favorites.data.map((fav) => {
      if (fav._id === id) {
        return {
          ...fav,
          dbName: fav.name,
        };
      }
      return fav;
    }),
  },
});

handlers[UPDATE_USER_FAVORITE_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[UPDATE_USER_FAVORITES] = (state, { favorites }) => ({
  ...state,
  favorites: {
    ...state.favorites,
    data: favorites,
  },
});

handlers[UPDATE_USER_FAVORITES_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[DELETE_USER_FAVORITE] = state => ({
  ...state,
  loading: true,
});

handlers[DELETE_USER_FAVORITE_SUCCESS] = (state, { id }) => ({
  ...state,
  loading: false,
  favorites: {
    active: false,
    data: state.favorites.data.filter(fav => fav._id !== id),
  },
});

handlers[DELETE_USER_FAVORITE_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[USER_FAVORITES_ACTIVE] = (state, { active }) => ({
  ...state,
  favorites: {
    active,
    data: [
      ...state.favorites.data,
    ],
  },
});

handlers[USER_FAVORITES_NEW_INVALID] = (state, { favoriteInvalid }) => ({
  ...state,
  favorites: {
    favoriteInvalid,
    data: [
      ...state.favorites.data,
    ],
  },
});

handlers[FETCH_USER_SETTINGS] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_USER_SETTINGS_SUCCESS] = (state, { settings }) => ({
  ...state,
  loading: false,
  settings,
});

handlers[FETCH_USER_SETTINGS_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[FETCH_PAYMENT_WARNINGS] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_PAYMENT_WARNINGS_SUCCESS] = (state, { warningType }) => ({
  ...state,
  loading: false,
  warningType,
});

handlers[FETCH_PAYMENT_WARNINGS_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[SET_USER_LOCATION] = state => ({
  ...state,
  loading: true,
});

handlers[SET_USER_LOCATION_SUCCESS] = (state, { location }) => ({
  ...state,
  loading: false,
  location,
});

handlers[SET_USER_LOCATION_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[SET_DFP_AD_ATTRIBUTES] = state => ({
  ...state,
  loading: true,
});

handlers[SET_DFP_AD_ATTRIBUTES_SUCCESS] = (state, { adAttributes }) => ({
  ...state,
  loading: false,
  adAttributes,
});

handlers[SET_DFP_AD_ATTRIBUTES_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[SET_USER_BW_WIND_WAVE_MODEL] = state => ({
  ...state,
  loading: true,
});

handlers[SET_USER_BW_WIND_WAVE_MODEL_SUCCESS] = (state, { bwWindWaveModel }) => ({
  ...state,
  loading: false,
  settings: {
    ...state.settings,
    bwWindWaveModel,
  },
});

handlers[SET_USER_BW_WIND_WAVE_MODEL_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[SET_USER_BW_UNIT_PREFERENCE] = state => ({
  ...state,
  loading: true,
});

handlers[SET_USER_BW_UNIT_PREFERENCE_SUCCESS] = (state, { bwUnitPreference }) => ({
  ...state,
  loading: false,
  settings: {
    ...state.settings,
    bwUnitPreference,
  },
});

handlers[SET_USER_BW_UNIT_PREFERENCE_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/user.js